import { PushEvent } from '../../../push-notifications';

export interface PusherEvent {
  name: string;
  data: string;
}

export class PusherEventImpl implements PushEvent {
  get code(): string {
    return this.data;
  }

  constructor(public readonly name: string, private readonly data: string) {}
}
